import { Component, OnInit, Output, EventEmitter, AfterViewInit, ElementRef, ViewChild, Input, OnChanges } from '@angular/core';
import MetisMenu from 'metismenujs/dist/metismenujs';

import { Router, NavigationEnd } from '@angular/router';

import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { TranslateService } from '@ngx-translate/core';
import { EventService } from '../../core/services/event.service';
import { GlobalService } from 'src/app/core/services/global.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

/**
 * Sidebar component
 */
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() isCondensed = false;
  @Output() mobileMenuButtonClicked = new EventEmitter();

  menu: any;

  menuItems = [];
  @ViewChild('sideMenu') sideMenu: ElementRef;
  @ViewChild('componentRef') scrollRef;
  isOverdraft = false;
  isReissue = false;
  isInsurance = false;
  refundCount = 0;
  reIssueCount = 0;
  pendingCount = 0;
  isCritical = 0;
  countryName;
  isQuotes = false;
  menuList = [];

  constructor(
    private eventService: EventService, 
    private router: Router, 
    public translate: TranslateService,
    private globalSrv: GlobalService
    ) {

    globalSrv.menuItems.subscribe((nextValue) => {
      if(nextValue != null){
        this.menuList = JSON.parse(nextValue);
        console.log(this.menuList.length)
        // this.menu = new MetisMenu(this.sideMenu.nativeElement);
        // this._activateMenuDropdown();   
      }
      // if(this.menuList && this.menuList.length > 0){
      //   setTimeout(() => {
      //     this.menu = new MetisMenu(this.sideMenu.nativeElement);
      //     this._activateMenuDropdown();        
      //   });        
      // }
    }) 
      
    globalSrv.overdraftStatus.subscribe((nextValue) => {
      this.isOverdraft = JSON.parse(nextValue);
    });
    globalSrv.refundCount.subscribe((nextValue) => {
      if(nextValue != null){
        this.refundCount = JSON.parse(nextValue);
      }
    })

    globalSrv.reIssueCount.subscribe((nextValue) => {
      this.reIssueCount = JSON.parse(nextValue);
    })

    globalSrv.reissueStatus.subscribe((nextValue) => {
      this.isReissue = JSON.parse(nextValue);
    })

    globalSrv.admStatus.subscribe((nextValue) => {
      this.isCritical = JSON.parse(nextValue);
    })
    
    globalSrv.insuranceStatus.subscribe((nextValue) => {
      this.isInsurance = JSON.parse(nextValue);
    })
    
    globalSrv.quotesStatus.subscribe((nextValue) => {
      this.isQuotes = JSON.parse(nextValue);
    })    

    globalSrv.pendingCount.subscribe((nextValue) => {
      if(nextValue != null){
        this.pendingCount = JSON.parse(nextValue);
      }
    })

    if(localStorage.getItem('country') != null){
      if(localStorage.getItem('country') == "Australia"){
        this.countryName = 'AU';
      }else{
        this.countryName = 'LK';        
      }
    }else{
      this.countryName = 'LK';        
    }

    router.events.forEach((event) => {
      // if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
        this._scrollElement();
      // }
    });


    // this.menuList = [
    //   '/',
    //   '/dashboard',
    //   '/quotes-list',
    //   '/ticketmanagement/issue-ticket',
    //   '/secondary-user'
    // ]
    // localStorage.setItem('a-routes',JSON.stringify(this.menuList));
  }


  ngOnInit() {
    this.initialize();
    this._scrollElement();
    document.body.setAttribute('data-sidebar', 'light');  
  }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string) {
    this.eventService.broadcast('changeLayout', layout);
  }

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
    this._activateMenuDropdown();
  }

  ngOnChanges() {
    if (!this.isCondensed && this.sideMenu || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Light sidebar
   */
  darkSidebar() {
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.removeAttribute('data-sidebar-size');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.classList.remove('vertical-collpsed');
  }

  /**
   * Compact sidebar
   */
  compactSidebar() {
    document.body.setAttribute('data-sidebar-size', 'small');
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.removeAttribute('data-topbar');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.classList.remove('sidebar-enable');
    document.body.classList.remove('vertical-collpsed');
  }

  /**
   * Icon sidebar
   */
  iconSidebar() {
    document.body.classList.add('sidebar-enable');
    document.body.classList.add('vertical-collpsed');
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.removeAttribute('data-topbar');
  }

  /**
   * Boxed layout
   */
  boxedLayout() {
    document.body.setAttribute('data-keep-enlarged', 'true');
    document.body.setAttribute('data-layout-size', 'boxed');
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.classList.add('vertical-collpsed');
    document.body.classList.remove('sidebar-enable');
    document.body.removeAttribute('data-topbar');
  }

  /**
   * Colored sidebar
   */
  coloredSidebar() {
    document.body.setAttribute('data-sidebar', 'colored');
    document.body.removeAttribute('data-sidebar-size');
    document.body.removeAttribute('data-layout-size');
    document.body.classList.remove('vertical-collpsed');
    document.body.removeAttribute('data-topbar');
  }

  _scrollElement() {
    setTimeout(() => {
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = document.getElementsByClassName("mm-active")[0]['offsetTop'];
        if (currentPosition > 500)
          if (this.scrollRef.SimpleBar.getScrollElement() !== null) {
            this.scrollRef.SimpleBar.getScrollElement().scrollTop =
              currentPosition + 300;
          }
      }
    }, 300);
  }
  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-active-title');
    this._removeAllClass('mm-show');
    this._removeAllClass('active');
    const links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;
    // tslint:disable-next-line: prefer-for-of
    const paths = [];
    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]['pathname']);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }
    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        if(menuItemEl.id === 'dashboard'){
          parentEl.classList.add('mm-active-title');
        }else{
          parentEl.classList.add('mm-active');
        }
        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');
            if (childAnchor) { childAnchor.classList.add('mm-active'); }
            if (childDropdown) { childDropdown.classList.add('mm-active'); }
            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') { childanchor.classList.add('mm-active'); }
              }
            }
          }
        }
      }
    }

  }

  /**
   * Initialize
   */
  initialize(): void {
    this.menuItems = MENU;
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  checkAvailableMenuItem(item: MenuItem){
    // return this.menuList.includes(item.link) ? true : false;
    // if(this.menuList){
      // console.log(this.menuList);
      if(this.menuList != undefined && this.menuList != null){
        let index = item.subItems.findIndex(x => this.menuList.includes(x.link));
        if(index > -1){
          return true;
        }else{
          return false;
        }  
      }else{
        return true;
      }      
    // }
  }

  checkAvailableSubMenuItem(subItem: MenuItem){
    if(this.menuList != undefined && this.menuList != null){
      let index = this.menuList.findIndex(x => subItem.link == x);
      if(index > -1){
        return true;
      }else{
        return false;
      } 
    }else{
      return true;
    }
      
  }

}
